import script from "./PatientAnketaLinkChannelsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAnketaLinkChannelsModal.vue?vue&type=script&setup=true&lang=js"

import "./PatientAnketaLinkChannelsModal.vue?vue&type=style&index=0&id=5934ece4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5934ece4"]])

export default __exports__